import { Table } from "antd";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useEffect, useState } from "react";
import UpdateRole from "./components/UpdateRole";
import DeleteRole from "./components/DeleteRole";
import CreateWrapper from "./components/CreateWrapper";
import fetchAllRoles from "../../../services/fetchAllRoles";

export default function AllRoles() {
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [roles, setRoles] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchRoles = async () => {
    setLoading(true);
    const data = await fetchAllRoles();
    setLoading(false);
    setRoles(data?.payload);
  };

  useEffect(() => {
    handleFetchRoles();
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 350,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.name === null ? "-" : record?.name}
        </span>
      ),
    },
    {
      title: "Active",
      width: 50,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.isActive ? (
            <div className="text-green-500">Yes</div>
          ) : (
            <div className="text-red-500">No</div>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      width: 40,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"Roles"}
      subtitle={"All"}
      description={"List of all user roles"}
      actions={<CreateWrapper handleFetchRoles={handleFetchRoles} />}
    >
      <div className="">
        <Table
          size="small"
          dataSource={roles}
          loading={isLoading}
          pagination={{ pageSize: 12 }}
          scroll={{ y: 625 }}
          columns={columns}
        />

        <UpdateRole
          selected={selected}
          isVisible={updateModal}
          setVisible={setUpdateModal}
          refetch={handleFetchRoles}
        />

        <DeleteRole
          selected={selected}
          isVisible={deleteModal}
          setDeleteModal={setDeleteModal}
        />
      </div>
    </Manage>
  );
}
